module.exports = __webpack_public_path__ + "img/flag-se.ed839554.svg";